import { cva } from "class-variance-authority";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const tagClass = cva(["text-black py-1 tablet:px-3.5 rounded-md tablet:font-bold h-fit"], {
  variants: {
    color: {
      gray: "tablet:bg-[#eff2ff]",
      red: "tablet:bg-[#F89090]",
    },
  },
  defaultVariants: {
    color: "gray",
  },
});

function TGTag({
  children,
  className,
  color = "gray",
}: {
  children: ReactNode;
  className?: string;
  color?: "gray" | "red";
}) {
  return <span className={twMerge(tagClass({ color: color }), className)}>{children}</span>;
}

export default TGTag;
